import type { TGetDetalhesLoteResponse } from '@/features/produtos/interfaces/detalhes-produto.types'
import { HttpService } from '@/shared/lib/http'

export class GetDetalhesLoteService extends HttpService {
  execute = async (idExterno: number) => {
    return this.http.get<TGetDetalhesLoteResponse>(`/api/v2/Produto/lote/${idExterno}/detalhes`)
  }
}
